import * as remoteAction from "../remoteAction";

export type LoyaltyQuestTokenActionSuccess =
  remoteAction.MerchantRemoteResponse<"LOYALTYQUEST_TOKEN_SUCCESS", any>;
export type LoyaltyQuestTokenActionFailure =
  remoteAction.MerchantRemoteResponse<"LOYALTYQUEST_TOKEN_FAILURE", any>;
export type LoyaltyQuestTokenActionRequest =
  remoteAction.MerchantRemoteResponse<"LOYALTYQUEST_TOKEN_REQUEST", any>;

export interface LoyaltyQuestTokenAction
  extends remoteAction.PostRemoteRequest {
  types: {
    request: "LOYALTYQUEST_TOKEN_REQUEST";
    success: "LOYALTYQUEST_TOKEN_SUCCESS";
    failure: "LOYALTYQUEST_TOKEN_FAILURE";
  };
}

/**
 * Action to fetch LoyaltyQuest button data when actionURL contains
 * loyaltyquest_jwt and loyaltyquest_client_id merge variables
 */
export function getLoyaltyQuestToken(): LoyaltyQuestTokenAction {
  return {
    method: "POST",
    type: "MERCHANT_REMOTE_REQUEST",
    types: {
      failure: "LOYALTYQUEST_TOKEN_FAILURE",
      request: "LOYALTYQUEST_TOKEN_REQUEST",
      success: "LOYALTYQUEST_TOKEN_SUCCESS",
    },
    data: {
      event: {
        type: "loyaltyquest_button_request",
      },
    },
    https: true,
    url: `/loyaltyquest/jwt`,
  };
}
